var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"magic-button",style:({ backgroundColor: _vm.back_color }),on:{"click":_vm.do_click}},[_vm._v(" "+_vm._s(_vm.btn_text)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }